import { render, staticRenderFns } from "./DigitalHeritage.vue?vue&type=template&id=0e5ce242"
import script from "./DigitalHeritage.vue?vue&type=script&lang=js"
export * from "./DigitalHeritage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports